import { AppValueTypes } from '@iotv/iotv-v3-types';
import { NormalCase, dateTimeNow } from '../NetworkSystem/cellFormatters/valueFormatters';
import { WrapLinkVOB } from '../factories/DataGrid';
export const GatewayListViewDefintion = {
    name: {
        key: 'name',
        type: AppValueTypes.STRING,
        label: 'Name',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    eui: {
        key: 'eui',
        type: AppValueTypes.STRING,
        label: 'EUI',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    position: {
        key: 'position',
        type: AppValueTypes.STRING,
        label: 'Position',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    property: {
        key: 'property',
        type: AppValueTypes.STRING,
        label: 'Property',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    networkKey: {
        key: 'networkKey',
        type: AppValueTypes.STRING,
        label: 'NW ID',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    manufacturer: {
        key: 'manufacturer',
        type: AppValueTypes.STRING,
        label: 'Manufacturer',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    model: {
        key: 'model',
        type: AppValueTypes.STRING,
        label: 'Model',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    state: {
        key: 'state',
        type: AppValueTypes.STRING,
        label: 'State',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    isAWOL: {
        key: 'isAWOL',
        type: AppValueTypes.BOOLEAN,
        label: 'Is AWOL',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastSeen: {
        key: 'lastSeen',
        type: AppValueTypes.DATE,
        label: 'Last Seen',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    dailyUpCount: {
        key: 'dailyUpCount',
        type: AppValueTypes.NUMBER,
        label: 'Daily Up Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    dailyDownCount: {
        key: 'dailyDownCount',
        type: AppValueTypes.NUMBER,
        label: 'Daily Down Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    deviceCount: {
        key: 'deviceCount',
        type: AppValueTypes.NUMBER,
        label: 'Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    // channelMessage: {
    //   key: 'channelMessage',
    //   type: AppValueTypes.STRING,
    //   label: 'Message Count',
    //   editable: false,
    //   precision: undefined,
    //   stateFn: undefined,
    //   unit: undefined,
    //   validationRx: undefined,
    //   enumKV: undefined,
    // },
    fCntJump: {
        key: 'fCntJump',
        type: AppValueTypes.NUMBER,
        label: 'Frame Count Jump',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastHourDevCount: {
        key: 'lastHourDevCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Hr Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastHourMsgCount: {
        key: 'lastHourMsgCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Hr Message Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastDayMsgCount: {
        key: 'lastDayMsgCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Day Message Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastDayDeviceCount: {
        key: 'lastDayDeviceCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Day Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    battery: {
        key: 'battery',
        type: AppValueTypes.NUMBER,
        label: 'Battery',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
};
export const GatewayColumnMap = {
    name: {
        headerName: 'Name',
        width: 200,
    },
    eui: {
        headerName: 'EUI',
        width: 180,
        renderCell: (p) => WrapLinkVOB(p, 'sk'),
    },
    position: {
        headerName: 'Position',
        width: 300,
    },
    property: {
        headerName: 'Property',
        width: 200,
    },
    networkKey: {
        headerName: 'Network Key',
        width: 150,
    },
    manufacturer: {
        headerName: 'Manufacturer',
        width: 150,
    },
    model: {
        headerName: 'Model',
        width: 100,
    },
    state: {
        headerName: 'State',
        valueFormatter: NormalCase,
        width: 100,
    },
    isAWOL: {
        headerName: 'Is AWOL',
        width: 100,
    },
    lastSeen: {
        headerName: 'Last Active',
        valueFormatter: dateTimeNow,
        width: 200,
    },
    dailyUpCount: {
        headerName: 'Daily Up Count',
        width: 150,
    },
    dailyDownCount: {
        headerName: 'Daily Down Count',
        width: 150,
    },
    deviceCount: {
        headerName: 'Device Count',
        width: 150,
    },
    channelMessage: {
        headerName: 'Message Count',
        width: 180,
    },
    fCntJump: {
        headerName: 'Frame Count Jump',
        width: 150,
    },
    lastHourDevCount: {
        headerName: 'Last Hr Device Count',
        width: 150,
    },
    lastHourMsgCount: {
        headerName: 'Last Hr Message Count',
        width: 150,
    },
    lastDayMsgCount: {
        headerName: 'Last Day Message Count',
        width: 150,
    },
    lastDayDeviceCount: {
        headerName: 'Last Day Device Count',
        width: 150,
    },
    battery: {
        headerName: 'Battery',
        width: 80,
    },
};
export const GatewayListContextViewKeyDefinitions = {
    customerGroup: {
        key: 'customerGroup',
        type: AppValueTypes.STRING,
        label: 'Customer Group',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    customer: {
        key: 'customer',
        type: AppValueTypes.STRING,
        label: 'Customer',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    gatewayGroup: {
        key: 'gatewayGroup',
        type: AppValueTypes.STRING,
        label: 'Gateway Group',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    property: {
        key: 'property',
        type: AppValueTypes.STRING,
        label: 'Property',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
};
